import { Menu } from 'components/Menu';
import { MenuItem } from 'components/Menu/MenuItem';
import { TabPanel, Tabs } from 'components/Tabs';
import { AddUserIcon } from 'components/icons/AddUserIcon';
import { CloseIcon } from 'components/icons/CloseIcon';
import { SearchIcon } from 'components/icons/SearchIcon';
import { VerticalEllipsisIcon } from 'components/icons/VerticalEllipsisIcon';
import { useContext, useEffect, useState } from 'react';
import api from 'services/api';
import { v4 as uuid } from 'uuid';
import { MODAL_ANIMATIONS, MODAL_TYPES } from '../constants';
import { ModalContext } from 'context/ModalContext';
import CustomizedHook from 'components/CustomAutocomplete';
import clsx from 'clsx';

interface RemoveChannelPeopleProps {
  onCancel: () => void;
  selectedChannel: any;
  user: any;
  tab: string;
}

export default function RemoveChannelPeople({ onCancel, selectedChannel, user, tab }: RemoveChannelPeopleProps) {
  const { showModal } = useContext(ModalContext);

  const RemoveChannelPeople = () => {
    api
      .post(`/api/users/channel/${selectedChannel.hash_id}/remove-member/`, {
        users: [user.member.user_id]
      })
      .then(() => {
        showModal(MODAL_TYPES.channel_members, {
          animation: MODAL_ANIMATIONS.fade,
          selectedChannel,
          tab
        });
      });
  };

  return (
    <div className="transparent font-lato">
      <div className="relative border bg-gray-bg-dark border-gray-300 rounded-lg bg-white pb-7 pt-9 w-screen md:w-[622px] md:min-h-[200px]">
        <div className="flex px-7">
          <span className="font-bold text-2xl leading-6 text-[#1A1C1D]">
            Remove {user.member.display_name} from # {selectedChannel.name}?
          </span>
          <CloseIcon
            className="ml-auto w-5 h-5 cursor-pointer opacity-70 hover:opacity-100"
            onClick={() => {
              showModal(MODAL_TYPES.channel_members, {
                animation: MODAL_ANIMATIONS.fade,
                selectedChannel,
                tab
              });
            }}
          />
        </div>
        <div className="px-7 mt-5">
          <p>They&apos;ll still be able to rejoin, or be added to the conversation.</p>
          <div className="flex text-[13px] px-4 mt-5">
            <button
              className="py-2 px-3 text-black border border-[#e7eaec] ml-auto rounded-md hover:bg-gray-200"
              onClick={() => {
                showModal(MODAL_TYPES.channel_members, {
                  animation: MODAL_ANIMATIONS.fade,
                  selectedChannel,
                  tab
                });
              }}
            >
              Cancel
            </button>
            <button className="bg-red-main py-2 px-4 text-white ml-2 rounded-md" onClick={RemoveChannelPeople}>
              Remove
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
